import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { Wrapper, ImageWrapper, ImageFrame, Button } from './styles';
import MediaEditor from '../../../containers/Editor/MediaEditor';
import Image from '../../../containers/ProfilePage/EditableUserAvatar/Image';
import { EditableType } from '../../../containers/Editor/constants';
import ImportManager from '../../../containers/ImportManager';
import { addUserAvatar, updateUserAvatar, removeUserAvatar, resetUserAvatar } from '../../../containers/ProfilePage/actions';
import { AvatarSize } from '../../../containers/ProfilePage/reducer';
import { getImageCenteredPositionAndSize, PositionAndSize } from '../../../containers/Editor/utils/helpers';
import Utils from '../../../utils';
import DriveItemUtils from '../../../utils/driveItem';

interface EditableUserAvatarProps {
	hasAvatar: boolean;
	isEdited: boolean;
	dispatch: Dispatch<StoreState>;
}

const EditableUserAvatar = ({ hasAvatar, isEdited, dispatch }: EditableUserAvatarProps) => {
	const [isActive, setIsActive] = React.useState(false);

	const handleLoad = (width: number, height: number) => {
		const positionAndSize = getImageCenteredPositionAndSize(AvatarSize.BIG, AvatarSize.BIG, width, height);
		dispatch(updateUserAvatar(positionAndSize));
	};

	const isEditedRef = React.useRef(isEdited);

	React.useEffect(() => {
		isEditedRef.current = isEdited;
	});

	React.useEffect(() => {
		return () => {
			// reset changes if it was not saved on the server
			if (isEditedRef.current) {
				dispatch(resetUserAvatar());
			}
		};
	}, []);

	return (
		<Wrapper>
			<ImageWrapper>
				<ImageFrame>
					{hasAvatar
						? (
							<MediaEditor
								type={EditableType.image}
								page={-1}
								id=""
								frameWidth={AvatarSize.BIG}
								frameHeight={AvatarSize.BIG}
								pageScale={1}
								isActive={isActive}
								canDragAndResize={true}
								isCustom={true}
								MediaComponent={Image}
								onLoad={handleLoad}
								onFrameClick={() => setIsActive(true)}
								onFrameClickOutside={() => setIsActive(false)}
								onMediaClickOutside={(positionAndSize: PositionAndSize) => dispatch(updateUserAvatar(positionAndSize))}
							/>
						)
						: Utils.getSvgIcon('iconset_uprez-user_avatar')
					}
				</ImageFrame>
				{!isActive && !hasAvatar &&
					<ImportManager
						id="user-avatar"
						triggerComponent={
							<Button
								as="div"
								isRemove={false}
							>
								{Utils.getSvgIcon('iconset_close-2')}
							</Button>
						}
						extensions={DriveItemUtils.imageWithSvgExtensions.join(',')}
						customImportHandler={(file, isCorrectFileType) => dispatch(addUserAvatar(file as File, isCorrectFileType))}
					/>
				}
				{!isActive && hasAvatar &&
					<Button
						type="button"
						isRemove={true}
						onClick={() => dispatch(removeUserAvatar())}
					>
						{Utils.getSvgIcon('iconset_close-2')}
					</Button>
				}
			</ImageWrapper>
		</Wrapper>
	);
};

export default EditableUserAvatar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/EditableUserAvatar/index.tsx